var _circle, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _circle2, _circle3, _ellipse4, _path5, _circle4, _circle5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShibariumRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    fill: "url(#shibaRedGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5 C7 7, 8 6, 9.5 6.5 C10.5 7, 10 8.5, 9 9 Z",
    fill: "#B71C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.2 C7.8 7.5, 8.5 7.2, 9 7.5 C9.2 8, 8.8 8.5, 8.5 8.8 Z",
    fill: "#EF5350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5 C17 7, 16 6, 14.5 6.5 C13.5 7, 14 8.5, 15 9 Z",
    fill: "#B71C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.2 C16.2 7.5, 15.5 7.2, 15 7.5 C14.8 8, 15.2 8.5, 15.5 8.8 Z",
    fill: "#EF5350"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13,
    rx: 6,
    ry: 5.5,
    fill: "url(#faceRedGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 11,
    rx: 1,
    ry: 1.5,
    fill: "#4A0E0E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 11,
    rx: 1,
    ry: 1.5,
    fill: "#4A0E0E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.8,
    cy: 10.5,
    r: 0.3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8,
    cy: 10.5,
    r: 0.3,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5,
    rx: 0.8,
    ry: 0.6,
    fill: "#4A0E0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2 C11 15.5, 13 15.5, 12 14.2",
    fill: "none",
    stroke: "#4A0E0E",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.5,
    r: 0.8,
    fill: "#FFCDD2",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 0.8,
    fill: "#FFCDD2",
    opacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "shibaRedGradient",
    cx: "50%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D32F2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "faceRedGradient",
    cx: "50%",
    cy: "40%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#FFCDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EF9A9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibariumRedIcon);
export default __webpack_public_path__ + "static/media/ShibariumRedIcon.aa95c1bcdd629867f74b59aa9f0b02f4.svg";
export { ForwardRef as ReactComponent };